import { all } from 'redux-saga/effects';
import authSaga from '~/reduxs/Auth/authSaga';
import customerSaga from '~/reduxs/Customer/customerSaga';
import supplierSaga from '~/reduxs/Supplier/supplierSaga';
import attributeSaga from '~/reduxs/Attribute/attributeSaga';
import productCategorySaga from '~/reduxs/ProductCategory/productCategorySaga';
import productSaga from '~/reduxs/Product/productSaga';
import userSaga from '~/reduxs/User/userSaga';
import purchaseOrderSaga from '~/reduxs/PurchaseOrder/purchaseOrderSaga';
import orderSaga from '~/reduxs/Order/orderSaga';

export default function* rootSaga() {
	yield all([
		authSaga(),
		supplierSaga(),
		customerSaga(),
		attributeSaga(),
		productCategorySaga(),
		productSaga(),
		userSaga(),
		purchaseOrderSaga(),
		orderSaga(),
	]);
}